import { useEffect, useState } from "react";
import { api } from "../api.js";
import { SectionHead, PartialErrors, Empty } from "./common.jsx";
import TaxProfile from "./TaxProfile.jsx";

const text = (v) => (v == null ? "" : String(v).trim());

// Облікова картка платника: блоки кабінету як є — поля (values) і таблиці (listValues).
// Порядок колонок — як у headers відповіді
// РНОКПП посадових осіб — у картці ДПС його немає; вносять тут, і звідси його беруть ПН, запити й повідомлення
function Officials({ companyId, value, onSaved }) {
  const [bos, setBos] = useState(value.bosRnokpp || ""), [buh, setBuh] = useState(value.buhRnokpp || ""), [st, setSt] = useState("");
  const ok = (v) => v === "" || /^\d{10}$/.test(v);
  const save = async (e) => {
    e.preventDefault(); setSt("зберігаємо…");
    try { await api(`/api/companies/${companyId}/card/officials`, { method: "PUT", body: { bosRnokpp: bos, buhRnokpp: buh } }); setSt("збережено"); onSaved?.(); }
    catch (x) { setSt(x.message); }
  };
  if (!value.canEdit) return value.bosRnokpp || value.buhRnokpp ? <p className="muted small">РНОКПП керівника: {value.bosRnokpp || "—"} · головного бухгалтера: {value.buhRnokpp || "—"}</p> : null;
  return (
    <form className="officials" onSubmit={save}>
      <label className="field">РНОКПП керівника<input inputMode="numeric" maxLength={10} value={bos} onChange={(e) => setBos(e.target.value.replace(/\D/g, ""))} aria-invalid={!ok(bos) || undefined} placeholder="10 цифр" /></label>
      <label className="field">РНОКПП головного бухгалтера<input inputMode="numeric" maxLength={10} value={buh} onChange={(e) => setBuh(e.target.value.replace(/\D/g, ""))} aria-invalid={!ok(buh) || undefined} placeholder="10 цифр" /></label>
      <button type="submit" className="btn btn-secondary btn-sm" disabled={!ok(bos) || !ok(buh)}>Зберегти</button>
      <span className="muted small" role="status">{st || "У картці ДПС РНОКПП немає — звідси його беруть ПН, запити й повідомлення"}</span>
    </form>
  );
}

function Block({ b, extra }) {
  const keys = Object.keys(b.headers || {});
  const pairs = keys.map((k) => [b.headers[k], text(b.values?.[k])]).filter(([, v]) => v);
  const list = Array.isArray(b.listValues) ? b.listValues : [];
  if (!pairs.length && !list.length) return null;
  return (
    <section className="card card-block">
      <h3>{b.title}</h3>
      {pairs.length > 0 && (
        <dl className="pairs">
          {pairs.map(([k, v], i) => <div key={i}><dt>{k}</dt><dd>{v}</dd></div>)}
        </dl>
      )}
      {extra}
      {list.length > 0 && (
        <div className="table-wrap">
          <table className="table-static table-card">
            <thead><tr>{keys.map((k) => <th key={k}>{b.headers[k]}</th>)}</tr></thead>
            <tbody>{list.map((row, i) => <tr key={i}>{keys.map((k) => <td key={k}>{text(row[k])}</td>)}</tr>)}</tbody>
          </table>
        </div>
      )}
    </section>
  );
}

export default function Card({ companyId, res, version, onSync, onProfileChange }) {
  const [card, setCard] = useState(undefined), [officials, setOfficials] = useState(null);
  useEffect(() => { api(`/api/companies/${companyId}/card`).then((r) => { setCard(r.card); setOfficials(r.officials || null); }); }, [companyId, version]);
  return (
    <>
      <SectionHead title="Облікова картка платника" res={res} onSync={onSync} />
      <PartialErrors res={res} />
      <TaxProfile key={version} companyId={companyId} onChange={onProfileChange} />
      {card === undefined ? <p className="muted">Завантаження…</p>
        : !card ? <Empty>Картку ще не завантажено. Натисніть «Оновити Дані компанії» вгорі.</Empty>
        : (card.blocks || []).map((b, i) => <Block key={b.idGroup ?? i} b={b}
          extra={officials && /керівник/i.test(b.title || "") ? <Officials companyId={companyId} value={officials} /> : null} />)}
    </>
  );
}
